var utmz = (function (module, $) {
  var utmzCookieArray,
    utmzObj = {},
    cookieArray,
    changes = 0;

  var init = function (attrs) {
    var a_Source = attrs.Source || "";
    var a_Medium = attrs.Medium || "";
    var a_Campaign = attrs.Campaign || "";
    var a_Content = attrs.Content || "";
    var a_GCLID = attrs.GCLID || "";
    cookieArray = document.cookie.split(";");
    var cLength = cookieArray.length;
    for (var i = 0; i < cLength; i++) {
      if (cookieArray[i].indexOf("__utmzz=") === 1) {
        utmzCookieArray = cookieArray[i].split("__utmzz=")[1].split("|");
        var ucLength = utmzCookieArray.length;
        for (var j = 0; j < ucLength; j++) {
          var ucv = utmzCookieArray[j].split("=");
          if (ucv[0] === "utmcsr") {
            if (ucv[1] !== a_Source) {
              utmzObj.Source = ucv[1];
              changes++;
            } else {
              utmzObj.Source = a_Source;
            }
          } else if (ucv[0] === "utmcmd") {
            if (ucv[1] !== a_Medium) {
              utmzObj.Medium = ucv[1];
              changes++;
            } else {
              utmzObj.Medium = a_Medium;
            }
          } else if (ucv[0] === "utmccn") {
            if (ucv[1] !== a_Campaign) {
              utmzObj.Campaign = ucv[1];
              changes++;
            } else {
              utmzObj.Campaign = a_Campaign;
            }
          } else if (ucv[0] === "utmcct") {
            if (ucv[1] !== a_Content) {
              utmzObj.Content = ucv[1];
              changes++;
            } else {
              utmzObj.Content = a_Content;
            }
          } else if (ucv[0] === "utmgclid") {
            if (ucv[1] !== a_GCLID) {
              utmzObj.GCLID = ucv[1];
              changes++;
            } else {
              utmzObj.GCLID = a_GCLID;
            }
          } else {
            utmzObj[ucv[0]] = ucv[1];
          }
        }
        if (ucLength > 0 && changes > 0) {
          utmzObj.utmzLoaded = "";
          utmzObj.Source = utmzObj.Source || "";
          utmzObj.Medium = utmzObj.Medium || "";
          utmzObj.Campaign = utmzObj.Campaign || "";
          utmzObj.Content = utmzObj.Content || "";
          utmzObj.GLCID = utmzObj.GLCID || "";
          updateAttributes();
        }
      }
    }
  };
  var updateAttributes = function () {
    $.post("/cart/update.js", { attributes: utmzObj });
  };
  module = {
    init: init,
    updateAttributes: updateAttributes,
  };
  return module;
})(utmz || {}, jQuery);
